import React, { useState, useEffect } from 'react';
import { useDateTimeSettings } from '../hooks/useDateTimeSettings';

interface ClockProps {
  onOpenWindow?: (appId: string, title: string) => void;
}

export const Clock: React.FC<ClockProps> = ({ onOpenWindow }) => {
  const [, setTime] = useState(new Date());
  const { getCurrentTime } = useDateTimeSettings();

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleRightClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onOpenWindow) {
      onOpenWindow('datetime-settings', 'Date & Time Settings');
    }
  };

  return (
    <div 
      className="text-sm font-medium text-taskbar-foreground bg-secondary px-2 py-1 rounded border border-border cursor-pointer hover:bg-secondary/80 transition-colors"
      onContextMenu={handleRightClick}
      title="Right-click to adjust date & time settings"
    >
      {getCurrentTime()}
    </div>
  );
};